// extracted by css-extract-rspack-plugin
export default {"suggestArray":"suggest-array--LJChJdwHgBUiDe7A"};